module.exports = __webpack_public_path__ + "img/employee_payrun.5b708007.svg";